module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "banner animated fadeInDown"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "center largeur"
  }, [_c('img', {
    attrs: {
      "border": "0",
      "alt": "logo",
      "src": 'img/logo_' + _vm.locale + '.png'
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.entete",
      modifiers: {
        "entete": true
      }
    }],
    staticClass: "baseline"
  }), _vm._v(" "), _c('div', {
    staticClass: "center largeur"
  }, [_c('button', {
    directives: [{
      name: "lang",
      rawName: "v-lang.demande-information",
      modifiers: {
        "demande-information": true
      }
    }],
    staticClass: "btn btn-large marg_b15 marg_t20",
    on: {
      "click": _vm.scroll
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    directives: [{
      name: "lang",
      rawName: "v-lang.plaquette-pdf",
      modifiers: {
        "plaquette-pdf": true
      }
    }],
    staticClass: "btn bis btn-small marg_r",
    on: {
      "click": _vm.dlplaquette
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "lang",
      rawName: "v-lang.communique-presse-pdf",
      modifiers: {
        "communique-presse-pdf": true
      }
    }],
    staticClass: "btn bis btn-small",
    on: {
      "click": _vm.dlpresse
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-top": "50px"
    }
  }, [_vm._l((_vm.langues), function(item, index) {
    return _c('Langue', {
      key: index,
      attrs: {
        "langue": item
      }
    })
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "lang",
      rawName: "v-lang.contacter-nous",
      modifiers: {
        "contacter-nous": true
      }
    }]
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c84cc8be","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Header.vue
// module id = 60
// module chunks = 0